<a
  scroll-menu-on-click
  (click)="selected.emit()"
  [ngClass]="{ active: active }">
  <i [class]="iconClass"></i>
  <ng-content></ng-content>
</a>
